import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private readonly vipMode: boolean = Boolean(
    (environment as any).VIP_MODE ?? false
  );

  constructor() { }

  public get isVipMode(): boolean {
    return this.vipMode;
  }

}
